"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.threads.title': 'Thread',
    'whatsapp.threads.count': 'Totale',
    'whatsapp.threads.noThreads': 'Nessun thread trovato.',
    'whatsapp.threads.noLogs': 'Nessun log di tracciamento in questo thread.',
    'whatsapp.threads.selectThread': 'Seleziona un thread per visualizzare i log.',
    'whatsapp.threads.showFinished': 'Mostra completati',
    'whatsapp.threads.finished': 'Completato',
    'whatsapp.threads.finish': 'Completa',
    'whatsapp.threads.reopen': 'Riapri',
    'whatsapp.threads.back': 'Indietro',
    'whatsapp.threads.confirmFinish': 'Segnare questo thread come completato?',
    'whatsapp.threads.finishFailed': 'Impossibile completare il thread.',
    'whatsapp.threads.source.group': 'Gruppo',
    'whatsapp.threads.source.email': 'Email',
    'whatsapp.threads.source.dm': 'Messaggio diretto',
};
